import {
	DC_NAME,
	DC_NUMBER,
	STORE,
	DC_INFORMATION,
	STORE_ON_HAND,
	STORE_ON_ORDER,
	REPL_INSTOCK_PCT,
	STORE_IN_TRANSIT,
	STORE_IN_WAREHOUSE,
	DC_ON_HAND,
	DC_ON_ORDER,
	SALES,
	UNITS,
	NILPICK_PCT,
	NILPICK_QUANTITY,
	UNIT_STORE_WEEK,
	DOLLAR_STORE_WEEK,
} from '../../constants/constant';

import {
	currencyFormatter,
	valueFormatterWithHyphen,
	numericalComparator,
	nameFormatterWithHyphen,
} from '../../redux/utils';

export const storeDrilldownColumns = (
	selectedWeekFilter,
	storeCountWithLessThreshold
) => {
	const getCustomHeaderName = (type, selectedWeekFilter) => {
		if (selectedWeekFilter !== -1) {
			return `L ${selectedWeekFilter} WMT Wks ${type}`;
		}
		return `Custom ${type}`;
	};

	const customUnitHeaderName = getCustomHeaderName('', selectedWeekFilter);
	const customYoYHeaderName = getCustomHeaderName(
		'YoY Chg',
		selectedWeekFilter
	);
	const customDollarHeaderName = getCustomHeaderName(
		'YoY $ Chg',
		selectedWeekFilter
	);
	const customPctHeaderName = getCustomHeaderName(
		'YoY % Chg',
		selectedWeekFilter
	);

	return [
		{
			sortable: true,
			field: 'storeNbr',
			headerName: `${STORE} (${storeCountWithLessThreshold})`,
			pinned: 'left',
			cellClass: ['pointer', 'left-aligned-text-padding'],
			headerComponent: 'customColumnMainHeader',
			headerComponentParams: {
				hasDefinition: true,
				definitionId: 'stores_sd',
				leftAlign: true,
			},
		},
		{
			headerName: DC_INFORMATION,
			children: [
				{
					field: 'nbr',
					headerName: DC_NUMBER,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'left-aligned-text-cell'],
					valueFormatter: nameFormatterWithHyphen,
					headerComponentParams: {
						hasDefinition: true,
						definitionId: 'dcNumber_sd',
						leftAlign: true,
						isStoreDrilldown: 'true',
					},
				},
				{
					field: 'nm',
					headerName: DC_NAME,
					cellClass: ['pointer', 'left-aligned-text-cell'],
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					valueFormatter: nameFormatterWithHyphen,
					headerComponentParams: {
						hasDefinition: true,
						definitionId: 'dcName_sd',
						leftAlign: true,
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: false,
				definitionId: 'dc_info',
			},
		},
		{
			headerName: REPL_INSTOCK_PCT,
			children: [
				{
					field: 'replInstkPercentageTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					comparator: numericalComparator,
					cellClass: ['pointer', 'right-aligned-text-padding'],
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'inStockYoYPctChg',
					headerName: customPctHeaderName,
					wrapHeaderText: true,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'replInstockPct_sd',
			},
		},
		{
			headerName: STORE_ON_HAND,
			children: [
				{
					field: 'storeOnHandQtyTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					comparator: numericalComparator,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeOnHandQtyYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					wrapHeaderText: true,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeOnHandQtyYoYPctChg',
					headerName: customPctHeaderName,
					wrapHeaderText: true,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'storeOnHand_sd',
			},
		},
		{
			headerName: STORE_ON_ORDER,
			children: [
				{
					field: 'storeOnOrderQtyTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeOnOrderQtyYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					wrapHeaderText: true,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeOnOrderQtyYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'storeOnOrder_sd',
			},
		},
		{
			headerName: STORE_IN_TRANSIT,
			children: [
				{
					field: 'storeInTransitQtyTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeInTransitQtyYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeInTransitQtyYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'storeInTransit_sd',
			},
		},
		{
			headerName: STORE_IN_WAREHOUSE,
			children: [
				{
					field: 'storeInWarehouseQtyTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeInWarehouseQtyYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'storeInWarehouseQtyYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'storeInWarehouse_sd',
			},
		},
		{
			headerName: DC_ON_HAND,
			children: [
				{
					field: 'dcOnHandTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dcOnHandYoY',
					valueFormatter: valueFormatterWithHyphen,
					headerName: customYoYHeaderName,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dcOnHandYoYPct',
					headerName: customPctHeaderName,
					sortable: true,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'dcOnHand_sd',
			},
		},
		{
			headerName: DC_ON_ORDER,
			children: [
				{
					field: 'dcOnOrderTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dcOnOrderYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dcOnOrderYoYPct',
					headerName: customPctHeaderName,
					sortable: true,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'dcOnOrder_sd',
			},
		},
		{
			headerName: UNITS,
			children: [
				{
					field: 'unitsTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'unitsYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'unitsYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'units_sd',
			},
		},
		{
			headerName: SALES,
			children: [
				{
					field: 'netSalesTY',
					headerName: customUnitHeaderName,
					valueFormatter: currencyFormatter,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'netSalesYoY',
					headerName: customDollarHeaderName,
					valueFormatter: currencyFormatter,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'netSalesYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'sales_sd',
			},
		},
		{
			headerName: NILPICK_PCT,
			children: [
				{
					field: 'nilPikRate',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'nilPickPct_sd',
			},
		},
		{
			headerName: NILPICK_QUANTITY,
			children: [
				{
					field: 'nilPickQty',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'nilPickQty_sd',
			},
		},
		{
			headerName: UNIT_STORE_WEEK,
			children: [
				{
					field: 'qtyStoreWkTY',
					headerName: customUnitHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'qtyStoreWkYoY',
					headerName: customYoYHeaderName,
					valueFormatter: valueFormatterWithHyphen,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'qtyStoreWkYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'units_store_wk_sd',
			},
		},
		{
			headerName: DOLLAR_STORE_WEEK,
			children: [
				{
					field: 'dollarStoreWkTY',
					headerName: customUnitHeaderName,
					valueFormatter: currencyFormatter,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dollarStoreWkYoY',
					headerName: customDollarHeaderName,
					valueFormatter: currencyFormatter,
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
				{
					field: 'dollarStoreWkYoYPctChg',
					headerName: customPctHeaderName,
					cellRenderer: 'CustomShareChgComponentNoUnit',
					sortable: true,
					filter: 'agNumberColumnFilter',
					headerComponent: 'customColumnHeader',
					cellClass: ['pointer', 'right-aligned-text-padding'],
					headerComponentParams: {
						isStoreDrilldown: true,
					},
				},
			],
			headerGroupComponent: 'customColumnMainHeader',
			headerGroupComponentParams: {
				hasDefinition: true,
				definitionId: 'dollar_store_wk_sd',
			},
		},
	];
};
